import React from 'react';
import { MessageSquare, ThumbsDown, ThumbsUp } from 'lucide-react';
import type { FeedbackSentiment } from './FeedbackModal';

interface MessageFeedbackControlsProps {
    feedbackProvided?: boolean;
    onOpenFeedback: (sentiment: FeedbackSentiment) => void;
}

export default function MessageFeedbackControls({
    feedbackProvided = false,
    onOpenFeedback,
}: MessageFeedbackControlsProps) {
    return (
        // Inline group — positioned within the shared meta row (after the
        // source icons) by the parent, which owns the top margin / alignment.
        <div className="flex flex-wrap items-center gap-1.5 text-xs">
            <button
                type="button"
                onClick={() => onOpenFeedback(null)}
                className="inline-flex h-7 items-center gap-1.5 rounded-md px-2 text-fg-tertiary transition-colors hover:bg-bg-warm hover:text-fg-secondary"
                aria-label="Give feedback on this response"
                title="Give feedback on this response"
            >
                <MessageSquare className="h-3.5 w-3.5" />
                Feedback
            </button>
            <button
                type="button"
                onClick={() => onOpenFeedback('positive')}
                className="inline-flex h-7 w-7 items-center justify-center rounded-md text-fg-tertiary transition-colors hover:bg-success/10 hover:text-success"
                aria-label="Mark this response as helpful"
                title="Mark this response as helpful"
            >
                <ThumbsUp className="h-3.5 w-3.5" />
            </button>
            <button
                type="button"
                onClick={() => onOpenFeedback('negative')}
                className="inline-flex h-7 w-7 items-center justify-center rounded-md text-fg-tertiary transition-colors hover:bg-danger/10 hover:text-danger"
                aria-label="Mark this response as not helpful"
                title="Mark this response as not helpful"
            >
                <ThumbsDown className="h-3.5 w-3.5" />
            </button>

            {feedbackProvided && (
                <span className="ml-1 text-[11px] text-fg-tertiary">
                    Feedback provided
                </span>
            )}
        </div>
    );
}
